import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React from "react";
import { activeFilter } from "../../../utils/consts";

const ActiveSelect = ({
  value,
  handleChangeFilter,
  label,
  active,
  inactive,
  all
}) => {
  return (
    <>
      <FormControl>
        <InputLabel id="project-simple-select-label">{label}</InputLabel>
        {/* No need to change on Autocomplete component (few options) */}
        <Select
          labelId="project-simple-select-label"
          id="project-simple-select"
          value={value ?? null}
          onChange={handleChangeFilter}
        >
          <MenuItem value={null}>{all}</MenuItem>
          <MenuItem
            value={activeFilter.TRUE}
          >
            {active}
          </MenuItem>
          <MenuItem
            value={activeFilter.FALSE}
          >
            {inactive}
          </MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default ActiveSelect;